<div class="login-body">
  <div class="login-image" [ngStyle]="background" (click)="calculateBackground()"></div>
  <div class="card login-panel  container-fluid">
    <div class="login-panel-content">
      <form #f="ngForm" (ngSubmit)="onSubmit()">
        <div class="login-spiner" [style.z-index]="show_spin" aria-hidden="true">
          <div class="nb-spinner" role="status">
            <span class="sr-only">...</span>
          </div>
        </div>
        <div class="row">
          <div class="col-3" style="text-align:left;">
            <img src="assets/img/icon-login.svg" />
          </div>
          <div class="col-9" style="text-align:right;">
            <h2 class="welcome-text">{{ 'LoginView.resetPassword' | translate }}</h2>
            <span class="guest-sign-in">{{ 'LoginView.mailAdvice' | translate }}</span>
          </div>
          <div class="col-12 p-2" style="text-align:left;">
            <label class="login-label">{{ 'LoginView.userOrMail' | translate }}</label>
            <div class="login-input">
              <input class="w-100" pInput id="userOrMail" name="userOrMail" type="text" [(ngModel)]="userOrMail"
                [ngModelOptions]="{ standalone: true }" autofocus autocapitalize="off" tabindex="1" />
            </div>
          </div>
          <div class="col-12 p-2 text-center">
            <button pButton tabindex="4" type="submit" class="btn btn-primary  btn-lg btn-block" id="btn"> Enviar correo
            </button>
            <a class="login-label" tabindex="6" href="#login">{{ 'LoginView.returnToLogin' | translate }}</a>
          </div>
          <div class="col-12 p-2 text-center" *ngIf="errorMsg">
            <span class="text-danger">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ errorMsg }}</span>
          </div>
          <!-- <div class="col-12 ui-md-6 link-pane">
            <a href="#">Forget Password?</a>
          </div> -->
        </div>
      </form>
    </div>
  </div>
</div>